import { memo } from 'react';
import { MenuItem } from 'consts/openBanking';
import { selectIsExportOpenBankingResourceLoading } from 'features/openBanking/selectors';
import { TableToolbar, type TableToolbarProps } from 'ui/widgets/Table';

const BankingSDKConnectorsRecipientsPivotToolbar = (props: Pick<TableToolbarProps, 'onExport'>) => (
    <TableToolbar
        {...props}
        selectIsExportLoading={selectIsExportOpenBankingResourceLoading(MenuItem.BankingSDKConnectorsRecipientsPivot)}
        dataTestIdPrefix='openBanking.table'
    />
);

export default memo(BankingSDKConnectorsRecipientsPivotToolbar);
